/* Terra Clava UI layer.
   Sticky add-to-cart, size-guide drawer, free-shipping progress, recently
   viewed, PDP hover zoom. Progressive: every piece no-ops if its markup
   is absent, so this file is safe on every template. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // labels carry a .visually-hidden a11y string; take only the visible text
  function labelText(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    Array.prototype.slice.call(c.querySelectorAll('.visually-hidden, .visually-hidden-if-js'))
      .forEach(function (n) { n.remove(); });
    return (c.textContent || '').trim();
  }
  // Free-shipping thresholds are set per zone in that zone's OWN currency, so they
  // never drift with the exchange rate:
  //   USD 150  - dearest single 125, two-tee pair 130, next pair 150
  //   CAD 200  - dearest single 175, two-tee pair 190, next pair 215
  // Each sits above the dearest single garment so nothing ships free on its own,
  // and above the two-tee pair, which is the one basket not worth subsidising.
  // Every other two-piece combination still qualifies.
  var FREE_SHIP_CENTS = { USD: 15000, CAD: 20000 };
  function freeShipThresholdCents(cart) {
    var cur = (cart && cart.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    return FREE_SHIP_CENTS[cur] || null;
  }

  /* ---------------------------------------------------------------- sticky */
  function stickyAddToCart() {
    var form = $('product-form');
    var data = $('[data-tc-product]');
    var submit = $('.product-form__submit');
    if (!form || !data || !submit) return;

    var bar = document.createElement('div');
    bar.className = 'tc-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="tc-sticky__inner">' +
        '<img class="tc-sticky__img" alt="" src="' + (data.dataset.img || '') + '">' +
        '<div class="tc-sticky__meta">' +
          '<p class="tc-sticky__name"></p>' +
          '<p class="tc-sticky__price"></p>' +
        '</div>' +
        '<div class="tc-sticky__opts"></div>' +
        '<button type="button" class="tc-sticky__cta"></button>' +
      '</div>';
    document.body.appendChild(bar);

    $('.tc-sticky__name', bar).textContent = data.dataset.title || '';

    function sync() {
      var price = $('.price-item--regular') || $('.price-item') || $('.price');
      if (price) $('.tc-sticky__price', bar).textContent = price.textContent.trim();
      var cta = $('.tc-sticky__cta', bar);
      cta.textContent = (submit.textContent || 'Add to cart').trim();
      cta.disabled = submit.disabled;
      // mirror the size options so the bar is usable, not decorative
      var opts = $('.tc-sticky__opts', bar);
      var picker = $$('.product-form__input--pill').pop();
      if (picker && !opts.dataset.built) {
        opts.dataset.built = '1';
        $$('input[type=radio]', picker).forEach(function (input) {
          var label = picker.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'tc-sticky__opt';
          b.textContent = labelText(label);
          b.disabled = input.disabled;
          if (input.checked) b.setAttribute('aria-current', 'true');
          b.addEventListener('click', function () { label.click(); });
          opts.appendChild(b);
        });
      }
      if (picker) {
        $$('.tc-sticky__opt', opts).forEach(function (b) {
          var input = $$('input[type=radio]', picker).filter(function (i) {
            var l = picker.querySelector('label[for="' + i.id + '"]');
            return l && labelText(l) === b.textContent.trim();
          })[0];
          if (input && input.checked) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }
    }
    sync();
    $('.tc-sticky__cta', bar).addEventListener('click', function () { submit.click(); });
    new MutationObserver(sync).observe(form, { subtree: true, childList: true, attributes: true });

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        bar.setAttribute('aria-hidden', bar.classList.contains('is-on') ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(submit);
  }

  /* ------------------------------------------------------------ size drawer
     Delegated. Quick-add modals inject their markup over AJAX after load, so
     binding once on DOMContentLoaded misses them entirely. */
  var sgEl = null;

  function sgBuild() {
    if (sgEl) return sgEl;
    sgEl = document.createElement('div');
    sgEl.className = 'tc-sg';
    sgEl.setAttribute('hidden', '');
    sgEl.innerHTML =
      '<div class="tc-sg__scrim" data-tc-size-close></div>' +
      '<aside class="tc-sg__panel" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<header class="tc-sg__head">' +
          '<div><p class="tc-sg__eyebrow">Size guide</p><h2 class="tc-sg__title"></h2>' +
          '<p class="tc-sg__spec"></p></div>' +
          '<button class="tc-sg__close" data-tc-size-close aria-label="Close">&times;</button>' +
        '</header>' +
        '<div class="tc-sg__units">' +
          '<button class="tc-sg__unitbtn is-on" data-unit="in">Inches</button>' +
          '<button class="tc-sg__unitbtn" data-unit="cm">Centimetres</button>' +
        '</div>' +
        '<div class="tc-sg__body"></div>' +
        '<p class="tc-sg__note">Measured flat. May vary by up to 1 inch (2.5 cm). ' +
        'Cuts are relaxed. Size down if you want it closer to the body.</p>' +
      '</aside>';
    document.body.appendChild(sgEl);
    sgEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-tc-size-close]')) sgClose();
      var u = e.target.closest('.tc-sg__unitbtn');
      if (u) sgUnit(u.dataset.unit);
    });
    return sgEl;
  }

  function sgUnit(u) {
    $$('.tc-sg__unit', sgEl).forEach(function (d) { d.hidden = d.dataset.unit !== u; });
    $$('.tc-sg__unitbtn', sgEl).forEach(function (b) { b.classList.toggle('is-on', b.dataset.unit === u); });
  }

  var sgLastFocus = null;
  function sgOpen(trigger) {
    // the chart template is the trigger's sibling, so quick-add and the PDP
    // each open their own product's chart rather than the first one on the page
    var scope = trigger.closest('.product__info-container, .quick-add-modal__content, product-info, .product') || document;
    var tpl = scope.querySelector('template[data-tc-size-chart]') || $('template[data-tc-size-chart]');
    if (!tpl) return;
    sgBuild();
    sgLastFocus = document.activeElement;
    $('.tc-sg__title', sgEl).textContent = trigger.dataset.title || trigger.dataset.garment || 'Size guide';
    $('.tc-sg__spec', sgEl).textContent =
      [trigger.dataset.gsm ? trigger.dataset.gsm + 'GSM' : '', trigger.dataset.comp].filter(Boolean).join(' \u00b7 ');
    var body = $('.tc-sg__body', sgEl);
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    sgUnit('in');
    sgEl.removeAttribute('hidden');
    requestAnimationFrame(function () { sgEl.classList.add('is-on'); });
    document.body.style.overflow = 'hidden';
    $('.tc-sg__close', sgEl).focus();
  }

  function sgClose() {
    if (!sgEl) return;
    sgEl.classList.remove('is-on');
    document.body.style.overflow = '';
    setTimeout(function () { sgEl.setAttribute('hidden', ''); }, 260);
    if (sgLastFocus && sgLastFocus.isConnected) sgLastFocus.focus();
  }

  function sizeDrawer() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tc-size-open]');
      if (!t) return;
      e.preventDefault();
      sgOpen(t);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sgEl && sgEl.classList.contains('is-on')) sgClose();
    });
  }

  /* --------------------------------------------------- free shipping meter */
  function shippingMeter() {
    // render() writes into .cart-drawer__footer, which lives INSIDE the
    // <cart-drawer> subtree the MutationObserver below watches. The write
    // re-fired the observer, which re-fetched /cart.js, which re-wrote the
    // DOM: a permanent ~2.2s poll on every page for every visitor, measured
    // at 20 requests in 20s. Detach the observers across our own write, and
    // skip the write entirely when the markup has not changed.
    var watched = [];
    var lastHTML = null;
    var timer = null;

    function markup(cents, threshold) {
      var left = threshold - cents;
      var pct = Math.max(0, Math.min(100, (cents / threshold) * 100));
      return '<p class="tc-ship-meter__text">' +
        (left > 0
          ? '$' + (left / 100).toFixed(0) + ' away from free shipping'
          : 'Free shipping unlocked') +
        '</p><div class="tc-ship-meter__track"><span style="width:' + pct + '%"></span></div>';
    }

    function paint(html) {
      var hosts = $$('.cart-drawer__footer, .cart__footer');
      var mounted = $$('.tc-ship-meter');
      if (!html) {
        if (mounted.length) { detach(); mounted.forEach(function (n) { n.remove(); }); attach(); }
        lastHTML = null;
        return;
      }
      if (!hosts.length) return;
      if (html === lastHTML && mounted.length === hosts.length) return;
      lastHTML = html;
      detach();
      mounted.forEach(function (n) { n.remove(); });
      hosts.forEach(function (host) {
        var n = document.createElement('div');
        n.className = 'tc-ship-meter';
        n.innerHTML = html;
        host.insertBefore(n, host.firstChild);
      });
      attach();
    }

    function detach() { watched.forEach(function (w) { w.observer.disconnect(); }); }
    function attach() {
      watched.forEach(function (w) {
        w.observer.observe(w.node, { childList: true, subtree: true });
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var t = freeShipThresholdCents(c);
          paint(t ? markup(c.total_price || 0, t) : '');
        })
        .catch(function () {});
    }

    function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 220); }

    refresh();
    document.addEventListener('cart:refresh', refresh);
    ['cart-drawer', 'cart-notification'].forEach(function (tag) {
      var n = document.querySelector(tag);
      if (!n) return;
      var o = new MutationObserver(schedule);
      watched.push({ node: n, observer: o });
    });
    attach();
  }

  /* -------------------------------------------------------- recently viewed */
  function recentlyViewed() {
    var KEY = 'tc_recent';
    var data = $('[data-tc-product]');
    // only record and surface this on product pages; it reads as filler elsewhere
    if (!data && !document.body.classList.contains('template-product')) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}

    if (data && data.dataset.url) {
      list = list.filter(function (i) { return i.url !== data.dataset.url; });
      list.unshift({ url: data.dataset.url, title: data.dataset.title, img: data.dataset.img });
      list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var others = list.filter(function (i) { return !data || i.url !== data.dataset.url; }).slice(0, 4);
    if (others.length < 2) return;
    var host = $('.product-recommendations') || $('#MainContent');
    if (!host) return;

    var sec = document.createElement('section');
    sec.className = 'tc-recent page-width';
    sec.innerHTML = '<p class="tc-recent__label">Recently viewed</p><div class="tc-recent__grid">' +
      others.map(function (i) {
        return '<a class="tc-recent__item" href="' + i.url + '">' +
          '<span class="tc-recent__media"><img src="' + i.img + '" alt="" loading="lazy"></span>' +
          '<span class="tc-recent__name">' + i.title + '</span></a>';
      }).join('') + '</div>';
    host.parentNode.insertBefore(sec, host.nextSibling);
  }

  /* ------------------------------------------------------------- hover zoom */
  function hoverZoom() {
    $$('.product__media-wrapper .product__media').forEach(function (fig) {
      var img = fig.querySelector('img');
      if (!img) return;
      fig.classList.add('tc-zoom');
      fig.addEventListener('pointermove', function (e) {
        var r = fig.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      fig.addEventListener('pointerleave', function () { img.style.transformOrigin = 'center'; });
    });
  }

  // archived products cannot be bought; drop the controls that imply they can
  function markArchived() {
    var note = $('.tc-pdp-archive');
    if (!note) return;
    var host = note.closest('.product__info-container') || note.parentNode;
    if (host) host.classList.add('tc-archived');
  }

  // "Complete the set" tiles post a real product form. Progressive enhancement:
  // intercept, POST to /cart/add.js, then fire cart:refresh so the drawer and the
  // shipping meter update in place. Without JS the native form post still works.
  function pairsQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-tc-pairs-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.tc-pairs__add');
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      var label = btn ? btn.textContent : 'Add';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (btn) btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        })
        .catch(function () { if (btn) btn.textContent = 'Try again'; })
        .then(function () {
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          }, 1600);
        });
    });
  }

  function init() {
    try { markArchived(); } catch (e) {}
    try { stickyAddToCart(); } catch (e) {}
    try { sizeDrawer(); } catch (e) {}
    try { shippingMeter(); } catch (e) {}
    try { recentlyViewed(); } catch (e) {}
    try { hoverZoom(); } catch (e) {}
    try { pairsQuickAdd(); } catch (e) {}
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

